import React from 'react';
import { Region } from 'types/model';
import { root } from './styles';

type Props = {
  regions: Region[];
};

export const DATA_QA_REGIONS_SEO = 'regions-seo';

export function RegionsSeo({ regions }: Props) {
  return (
    <div className={root} data-qa={DATA_QA_REGIONS_SEO}>
      {regions?.map(({ regionName, currentPageLink }) => {
        const href = new URL(currentPageLink).origin;
        return (
          <a key={regionName} href={href}>
            {regionName}
          </a>
        );
      })}
    </div>
  );
}
